








import { Vue, Component, Model, Prop } from "vue-property-decorator";

@Component({})
export default class BaseTab extends Vue {
  @Prop()
  private value!: any;

  @Model("selected")
  readonly selected!: any;
}
